import React from 'react';
import '../../../styles/popUp.scss'

const PopUpSubscribeTamplate = ({setIsSubscribe, setIsPopUpSubscribe}) => {
    
    const hendlerAddPremium = () =>{
        setIsSubscribe(true)
        setIsPopUpSubscribe(false)
    }
    return (
        <div className='pop_up_wrap'>
            <div className='pop_up_wrap_content_subscribe'>
                <div className='pop_up_wrap_content_subscribe_left_block'>
                    <img src="/img/subscribeImage.svg" alt="" />
                </div>
                <div className='pop_up_wrap_content_subscribe_right_block'>
                    <div className='pop_up_wrap_content_subscribe_right_block_cont'>
                        <div className='pop_up_wrap_content_subscribe_right_block_title'> 
                        <p>Woah! You’ve discovered a <span>Premium</span>  feature! Upgrade to unlock it. </p>
                        </div>
                        <div className='pop_up_wrap_content_subscribe_right_block_text'>
                            <div className='pop_up_wrap_content_subscribe_right_block_text_item'> <img src="/img/Tick.svg" alt="" /> <p>Fully refundable for 7 days</p></div>
                            <div className='pop_up_wrap_content_subscribe_right_block_text_item'> <img src="/img/Tick.svg" alt="" /> <p>Unlock all advanced security features</p></div>
                            <div className='pop_up_wrap_content_subscribe_right_block_text_item'> <img src="/img/Tick.svg" alt="" /> <p>Priority support</p></div>
                            <div className='pop_up_wrap_content_subscribe_right_block_text_item'> <img src="/img/Tick.svg" alt="" /> <p>Dedicated resources for lower latency</p></div>
                        </div>
                        <div className='pop_up_wrap_content_subscribe_right_block_btn'>
                            <button
                                id='premium' 
                                className='pop_up_wrap_content_subscribe_right_block_btn_premium'
                                onClick={()=>hendlerAddPremium()}
                            >
                                Upgrade to Premium
                                <img src="/img/Premium Icon.svg" alt="" />
                                <label htmlFor="premium">-50%</label>
                                </button>
                            <button 
                            className='pop_up_wrap_content_subscribe_right_block_btn_premium_second'
                            onClick={()=>setIsPopUpSubscribe(false)}
                            >Not now</button>
                        </div>
                    </div>
                </div>

            </div>
            
        </div>
    );
};

export default PopUpSubscribeTamplate;